import React, { FC, useEffect, useRef, useState } from "react";
import { Filter } from "./filter/Filter";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
  TiEdit,
} from "react-icons/ti";
import {
  Column,
  Table,
  flexRender,
  getCoreRowModel,
  useReactTable,
  createColumnHelper,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  FilterFn,
  ColumnFiltersState,
  orderColumns,
  Row,
} from "@tanstack/react-table";

import {
  DndContext,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  closestCenter,
  type DragEndEvent,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { restrictToHorizontalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";

// needed for row & cell level scope DnD setup
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { DragAlongCell } from "./dnd/DragAlongCell";
import { DraggableTableHeader } from "./dnd/DraggableTableHeader";
import classes from "./TanStackTable.module.scss";
import Pagination from "./pagination/Pagination";
import { useFetchProcesses } from "../../hooks/useFetchProcesses";
import { factory } from "typescript";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { userState } from "../../states/userState";
import {
  columnState,
  columnOrderState,
  columnVisibilityState,
} from "../../states/columnState";
import { useColumnsSetting } from "../../hooks/useColumnsSetting";
import { ErrorModal } from "../uikit/atoms/modal/ErrorModal";
import { loadingState, loadingText } from "../../states/loadingState";
import { Columns, User } from "../../types/index";
import { useUserStateLocalstorage } from "../../hooks/useUserStateLocalstorage";
import { kintoneArrayState } from "../../states/kintonArrayState";
import { isActiveFetchState, isOnlySearchState } from "../../states/fetchState";
import {
  setUserToLocalStorage,
  getUserFromLocalStorage,
} from "../../lib/localStorageManager";
import RecordDetailForm from "../modal/RecordDetailForm";
import { Export, filteredArrayState } from "../../states/filteredArrayState";
import { foreColor } from "../../commons/colors";
import {
  VIEW_ID_5253,
  VIEW_ID_54,
  VIEW_ID_ALL_FACTORY,
  VIEW_ID_PT,
  VIEW_ID_PV,
  VIEW_ID_SITE,
} from "../../commons/views";
type Url = {
  name: string;
  url: string;
};

// type ColumnVisibilityProps = {
//   columnVisibility: Record<string, boolean>;
// };
// const columnVisibility = {
//   WID: true, // IDはcolumnHelperで定義したIDと一致させる
//   title: true,
//   body: false, // 初期状態で非表示にしたい場合はfalseを指定
//   url: true,
//   update: true,
//   delete: true,
// };
const TanStackTable: FC = () => {
  const [isActiveFilter, setIsActiveFilter] = useState(false);
  const [user, setUser] = useRecoilState<User>(userState);
  const [filteredArray, setFilteredArray] = useRecoilState(filteredArrayState);
  const [targetRow, setTargetRow] = useState(null);
  // const [isFirstRender, setIsFirstRender] = useState<boolean>(true);
  console.log("Dnd localstorage", getUserFromLocalStorage());
  const [isOnlySearch, setIsOnlySearch] =
    useRecoilState<boolean>(isOnlySearchState);
  const [columnFilters, setColumnFilters] = React.useState<ColumnFiltersState>(
    user.tableParams.columnFilters
  );
  const { error, getProcessForFactory, getProcessForSite } =
    useFetchProcesses();
  const {
    createColumnsAndDataSetting,
    createColumnsSetting,
    createDataSetting,
  } = useColumnsSetting();
  const [globalFilter, setGlobalFilter] = useState(user.tableParams.keywords);
  const [sorting, setSorting] = useState<Array<any>>(user.tableParams.sorting);
  const [title, setTitle] = useState("API連携エラー");
  const [message, setMessage] = useState("データ取得に失敗しました");
  const [isShowErrorDialog, setIsShowErrorDialog] = useState(false);
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const [isAciveFetch, setIsAciveFetch] = useRecoilState(isActiveFetchState);
  // const [toggle,setToggle] =useState<boolean>(false);
  const [pageSize, setPageSize] = useState(
    user.tableParams.selectedDisplayNumber
  ); // 初期値はお好みで
  const [pageIndex, setPageIndex] = useState(user.tableParams.selectedPage - 1); // 0は最初のページ
  // const [kintoneArray, setKintoneArray] = useState<any[] | null>(null);
  const [kintoneArray, setKintoneArray] = useRecoilState(kintoneArrayState);
  // const [columns, setColumns] = useState<any>([]);
  // const [columnOrder, setColumnOrder] = useState<Array<string> | Array<any>>(
  //   []
  // );
  const [columns, setColumns] = useRecoilState(columnState);
  const [data, setData] = useState<any>([]);

  const [columnOrder, setColumnOrder] = useRecoilState(columnOrderState);
  const [columnVisibility, setColumnVisibility] = useRecoilState(
    columnVisibilityState
  );
  // const [columnVisibility, setColumnVisibility] = useState<
  //   Record<string, boolean>
  // >({});
  // const [pageSize, setPageSize] = useState<number>(20);

  //センサーの設定
  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { distance: 5 } })
    // useSensor(MouseSensor, {}),
    // useSensor(TouchSensor, {}),
    // useSensor(KeyboardSensor, {})
  );
  const [isShowDetailForm, setIsShowDetailForm] = useState(false);
  // カラムフィルタがアクティブかどうかを追跡するステート
  const [isFiltering, setIsFiltering] = useState(false);
  //テーブル生成
  useEffect(() => {
    if (user.tableParams.selectedPage === 1) {
      console.trace("tableParamsデバッグ", user.tableParams);
    }
  }, [user.tableParams.selectedPage]);
  console.log("comp data kintoneArray", data[0], kintoneArray[0]);
  const table = useReactTable({
    data: data,

    columns,
    state: {
      columnFilters,
      globalFilter,
      columnOrder,
      pagination: { pageIndex, pageSize },
      sorting,
      columnVisibility,
    },
    onColumnOrderChange: setColumnOrder,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    initialState: {
      pagination: {
        pageSize: pageSize,
        pageIndex: pageIndex,
      },
      columnVisibility: columnVisibility,
    },
    debugTable: true,
    debugHeaders: true,
    debugColumns: true,
  });
  // console.log("columns,visibility", columnOrder, columnVisibility, columns);
  //データのフェッチ
  const fetchProcessForFactory = async (viewId: number, headerOnly = false) => {
    const factoryIds = user.filters.factory; //全件は0を指定する
    const situations = user.filters.situation; //全件は0を指定する
    const productNo = user.filters.productNo;
    const salesNo = user.filters.salesNo;
    const dateField = user.filters.dateField;
    const fromDate = user.filters.fromDate;
    const toDate = user.filters.toDate;
    const productItems = null; //品目区分追加時に実装する
    setLoadingAnimation(true);
    setLoadingText("データ取得中...");
    try {
      const response = await getProcessForFactory({
        factoryIds,
        situations,
        productNo,
        salesNo,
        dateField,
        fromDate,
        toDate,
        headerOnly,
        viewId,
        productItems,
      });
      if (error) throw new Error(error);
      return response;
    } catch (e) {
      setMessage("データ取得に失敗しました");
      setIsShowErrorDialog(true);
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };
  const fetchProcessForSite = async (headerOnly = false) => {
    const factoryIds = user.filters.factory; //全件は0を指定する
    const situations = user.filters.situation; //全件は0を指定する
    const productNo = user.filters.productNo;
    const salesNo = user.filters.salesNo;
    const dateField = user.filters.dateField;
    const fromDate = user.filters.fromDate;
    const toDate = user.filters.toDate;
    const viewId = user.viewId;
    const productItems = null; //品目区分追加時に実装する
    setLoadingAnimation(true);
    setLoadingText("データ取得中...");
    try {
      const response = await getProcessForSite({
        factoryIds,
        situations,
        productNo,
        salesNo,
        dateField,
        fromDate,
        toDate,
        headerOnly,
        viewId,
        productItems,
      });
      if (error) throw new Error(error);
      return response;
    } catch (e) {
      setMessage("データ取得に失敗しました");
      setIsShowErrorDialog(true);
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };

  const { updateColumnsOrder } = useUserStateLocalstorage();
  useEffect(() => {
    if (user?.isAuth === false) return;
    //初回のヘッダ生成
    const makeHeader = async () => {
      //1件ずつフェッチ
      if (user.columnsAllFactory.length === 0) {
        let result = await fetchProcessForFactory(VIEW_ID_ALL_FACTORY, true);
        createColumnsSetting(
          result[0] || [],
          result || [],
          VIEW_ID_ALL_FACTORY
        );
      }

      if (user.columnsPT.length === 0) {
        let result = await fetchProcessForFactory(VIEW_ID_PT, true);
        createColumnsSetting(result[0] || [], result || [], VIEW_ID_PT);
      }
      if (user.columnsPV.length === 0) {
        let result = await fetchProcessForFactory(VIEW_ID_PV, true);
        createColumnsSetting(result[0] || [], result || [], VIEW_ID_PV);
      }
      if (user.columnsKanto.length === 0) {
        let result = await fetchProcessForFactory(VIEW_ID_54, true);
        createColumnsSetting(result[0] || [], result || [], VIEW_ID_54);
      }
      if (user.columnsFukuokaKumamoto.length === 0) {
        let result = await fetchProcessForFactory(VIEW_ID_5253, true);
        createColumnsSetting(result[0] || [], result || [], VIEW_ID_5253);
      }
      if (user.columnsSite.length === 0) {
        let result = await fetchProcessForSite(true);
        createColumnsSetting(result[0] || [], result || [], VIEW_ID_SITE);
      }
    };

    (async () => {
      let result;
      //初回ヘッダ作成
      const isColumnsEmpty = () => {
        return (
          user.columnsAllFactory.length === 0 ||
          user.columnsPT.length === 0 ||
          user.columnsPV.length === 0 ||
          user.columnsKanto.length === 0 ||
          user.columnsFukuokaKumamoto.length === 0 ||
          user.columnsSite.length === 0
        );
      };
      if (isColumnsEmpty()) {
        await makeHeader();
      }
      //kintoneが空の場合のみフェッチ
      if (kintoneArray.length > 0) return;
      if (user.viewId !== 9999) {
        result = await fetchProcessForFactory(user.viewId);
        console.log("result", result);
      } else {
        result = await fetchProcessForSite();
      }
      if (result == undefined) {
        setKintoneArray([]);
        return;
      }
      setKintoneArray(result);
      // table.setPageIndex(user.tableParams.selectedPage);
    })();

    // setIsFirstRender(false);
    setIsAciveFetch(false);
    setIsActiveFilter(false);
    console.log("初回レンダリング");
  }, []);

  //カラム・データの設定
  useEffect(() => {
    // 条件を満たすかどうかを判断するためのフラグ
    const shouldUpdate = (() => {
      switch (user.viewId) {
        case VIEW_ID_ALL_FACTORY:
          return kintoneArray.length > 0 || user.columnsAllFactory.length > 0;
        case VIEW_ID_PT:
          return kintoneArray.length > 0 || user.columnsPT.length > 0;
        case VIEW_ID_PV:
          return kintoneArray.length > 0 || user.columnsPV.length > 0;
        case VIEW_ID_54:
          return kintoneArray.length > 0 || user.columnsKanto.length > 0;
        case VIEW_ID_5253:
          return (
            kintoneArray.length > 0 || user.columnsFukuokaKumamoto.length > 0
          );
        default:
          return kintoneArray.length > 0 || user.columnsSite.length > 0;
      }
    })();
    if (shouldUpdate) {
      if (!isOnlySearch) {
        const newColumsAndData = createColumnsAndDataSetting(
          kintoneArray[0] || [],
          kintoneArray || []
        );
        // console.log("kintoneArray", kintoneArray);
        setColumns(newColumsAndData.columns);
        setData(
          newColumsAndData.data.map((row: any) => {
            Object.keys(row).forEach((column: any) => {
              if (row[column]) {
                row[column] = row[column].toString();
              } else {
                row[column] = "";
              }
            });
            return row;
          })
        );
        setColumnVisibility(newColumsAndData.columnVisibility);
        if (isAciveFetch) {
          console.log("頁リセットしだよ-ビューセット");
          setUser((prevUser: User) => {
            const newUser = {
              ...prevUser,
              tableParams: {
                ...prevUser.tableParams,
                selectedPage: 1,
                junmpPage: "1",
                keywords: "",
                sorting: [],
                columnFilters: [],
                selectedDisplayNumber: 20,
              },
            };
            setUserToLocalStorage(newUser);
            // table.setPageIndex(1);
            return newUser;
          });
          setPageIndex(0);
          setPageSize(20);
          setSorting([]);
          setColumnFilters([]);
          setGlobalFilter("");
          setIsAciveFetch(false);
          // setIsOnlySearch(true);
          // table.setPageIndex(1);
        }
      } else {
        //検索のみの場合
        console.log("検索のみの場合ルートチェック");
        const data = createDataSetting(kintoneArray || []);
        setData(data);
        // setIsOnlySearch(false);
        if (isAciveFetch) {
          console.log("頁リセットしだよ-検索");
          setUser((prevUser: User) => {
            const newUser = {
              ...prevUser,
              tableParams: {
                ...prevUser.tableParams,
                selectedPage: 1,
                junmpPage: "1",
                sorting: [],
                columnFilters: [],
              },
            };
            setUserToLocalStorage(newUser);
            // table.setPageIndex(1);
            return newUser;
          });
          setPageIndex(0);
          setSorting([]);
          setColumnFilters([]);
          setIsAciveFetch(false);
          setIsOnlySearch(false);
          // table.setPageIndex(1);
        }
      }
    }
  }, [kintoneArray]);
  useEffect(() => {
    console.log("だよページ", table.getState().pagination.pageIndex);
    // table.
  }, [table.getState().pagination.pageIndex]);
  //オーダーの設定
  useEffect(() => {
    setColumnOrder(columns.map((col: any) => col.id));
    // setColumnVisibility(columns.map((col: any) =>{ return{[col.id]:col.}})
    // console.log("columns", columns, "columnOrder", columnOrder);
  }, [columns]);
  //userステート・ローカルストレージの更新
  useEffect(() => {
    updateColumnsOrder(columnOrder);
    //updateColumsVisibility(columnVisibility);を作る
    console.log();
  }, [columnOrder]); //依存関係にVisibilityを入れる
  useEffect(() => {
    table.setColumnVisibility(columnVisibility);
    console.log("columnVisibility", columns, "", columnVisibility);
  }, [columnVisibility]);

  //DND用
  function handleDragEnd(event: DragEndEvent) {
    const { active, over } = event;
    if (active && over && active.id !== over.id) {
      setColumnOrder((columnOrder) => {
        const oldIndex = columnOrder.indexOf(active.id as string);
        const newIndex = columnOrder.indexOf(over.id as string);
        return arrayMove(columnOrder, oldIndex, newIndex); //this is just a splice util
      });
    }
  }
  //ページインデックス
  useEffect(() => {
    setPageIndex(user.tableParams.selectedPage - 1);
  }, [user.tableParams.selectedPage]);
  //ソート
  useEffect(() => {
    console.log("sorting", sorting);
    setUser((prevUser: User) => {
      const newUser = {
        ...prevUser,
        tableParams: {
          ...prevUser.tableParams,
          sorting: sorting,
        },
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  }, [sorting]);
  //カラムフィルタ
  useEffect(() => {
    setUser((prevUser: User) => {
      const newUser = {
        ...prevUser,
        tableParams: {
          ...prevUser.tableParams,
          columnFilters: columnFilters,
        },
      };
      setUserToLocalStorage(newUser);
      return newUser;
    });
  }, [columnFilters]);
  //行クリック時の処理
  const handelRowClick = (row: any) => {
    // console.log("Detail確認row", row.getAllCells());

    setTargetRow(row.getAllCells());
    setIsShowDetailForm(true);
  };
  // フィルタ条件が変更されたときにフィルタリングされたデータを取得する
  useEffect(() => {
    // getFilteredRowModel()を使用してフィルタリングされた行モデルを取得
    const filteredRows = table.getFilteredRowModel().rows;

    // フィルタリングされた行データの配列を抽出
    const filteredData = filteredRows.map((row) => row.original as Export);
    setFilteredArray(filteredData);
    setIsActiveFilter(true);
  }, [table.getState().columnFilters, table.getState().globalFilter]); // フィルタ条件が変更されたときにのみ実行
  return (
    <>
      <div className={classes.rootContainer}>
        <Pagination
          table={table}
          pageSize={pageSize}
          setPageSize={setPageSize}
          setIsActive={setIsActiveFilter}
          isActive={isActiveFilter}
        />
        <DndContext
          collisionDetection={closestCenter}
          modifiers={[restrictToHorizontalAxis]}
          onDragEnd={handleDragEnd}
          sensors={sensors}
        >
          <div className={classes.tableContainer}>
            <table className={classes.table}>
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    <SortableContext
                      items={columnOrder}
                      strategy={horizontalListSortingStrategy}
                    >
                      {headerGroup.headers.map((header) => (
                        // <th key={header.id}>
                        //   <div onClick={header.column.getToggleSortingHandler()}>
                        //     {flexRender(
                        //       header.column.columnDef.header,
                        //       header.getContext()
                        //     )}
                        //     {{
                        //       asc: <TiArrowSortedUp />,
                        //       desc: <TiArrowSortedDown />,
                        //     }[header.column.getIsSorted() as string] ?? (
                        //       <TiArrowUnsorted />
                        //     )}
                        //   </div>
                        //   {header.column.getCanFilter() ? (
                        //     <div>
                        //       <Filter column={header.column} table={table} />
                        //     </div>
                        //   ) : null}
                        // </th>
                        <DraggableTableHeader
                          key={header.id}
                          header={header}
                          table={table}
                        />
                      ))}
                    </SortableContext>
                  </tr>
                ))}
              </thead>
              <tbody
                className={
                  user?.mode === "lite" ? classes.tbodyLite : classes.tbodyDark
                }
              >
                {table.getRowModel().rows.map((row) => (
                  <tr key={row.id} onClick={() => handelRowClick(row)}>
                    {/* {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))} */}
                    {row.getVisibleCells().map((cell) => (
                      <SortableContext
                        key={cell.id}
                        items={columnOrder}
                        strategy={horizontalListSortingStrategy}
                      >
                        <DragAlongCell key={cell.id} cell={cell} />
                      </SortableContext>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </DndContext>
        {/* <p>Rows Number: {table.getRowModel().rows.length}</p> */}
      </div>
      {isShowErrorDialog && (
        <ErrorModal
          title={title}
          message={message}
          setIsShow={setIsShowErrorDialog}
        />
      )}
      {isShowDetailForm && (
        <RecordDetailForm
          setIsShow={setIsShowDetailForm}
          data={targetRow}
          tableData={data}
          setTableData={setData}
        />
      )}
    </>
  );
};

export default TanStackTable;
